import React, { useState, useEffect } from "react";
import Address from "../components/address/Address";
import { useHistory } from "react-router";
import axios from "axios";
import { useSnackbar } from "notistack";
import PageWrapper from "../components/PageWrapper/PageWrapper";
import BackButton from "../components/BackButton";


const MyAddress = () => {
    const [selectedAddressId, setSelectedAddressId] = useState(null);

  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const handleAddressSelect = (id) => {
    setSelectedAddressId(id);
  };

  return (
    <PageWrapper>
      <div className="mx-auto w-full max-w-3xl px-4 py-4 sm:px-6 sm:py-6">
        <BackButton />
        <h1 className="text-2xl sm:text-3xl font-bold mt-4 mb-6">My Address</h1>
        <Address onAddressSelect={handleAddressSelect} showRadio={false} isEdit />
      </div>
    </PageWrapper>
  );
};

export default MyAddress;
